// extracted by mini-css-extract-plugin
export var closeButton = "_3x-3";
export var header = "_3x-0";
export var link = "_3x-1";
export var retryButton = "_3x-2";